import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'
import { ReportDictationMode } from '@services/MemberPreferenceConfigService'
import {
  doGetMemberPreferenceConfig,
  doUpsertMemberPreferenceConfig,
} from '@state/reducers/memberPreferenceConfigReducer'
import { DICTATION_MODE_LABELS } from '@utils/constants'
import { useEffect, useState } from 'react'

const MemberPreferenceConfig = () => {
  const dispatch = useAppDispatch()
  const memberId = useAppSelector((state) => state.auth.user?.id)
  const { config, loading } = useAppSelector(
    (state) => state.memberPreferenceConfig,
  )

  const [editMode, setEditMode] = useState(false)
  const [selectedMode, setSelectedMode] = useState<ReportDictationMode | ''>('')

  useEffect(() => {
    if (memberId) {
      dispatch(doGetMemberPreferenceConfig(memberId))
    }
  }, [dispatch, memberId])

  const handleEdit = () => {
    setSelectedMode(config?.reportDictationMode ?? '')
    setEditMode(true)
  }

  const handleCancel = () => {
    setEditMode(false)
  }

  const handleSave = async () => {
    if (!memberId || !selectedMode) return
    await dispatch(
      doUpsertMemberPreferenceConfig({
        memberId,
        reportDictationMode: selectedMode,
      }),
    )
    setEditMode(false)
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2 }}>
        <CircularProgress size={20} />
        <Typography variant="body2">Chargement...</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {!editMode ? (
          <Typography variant="h5" minWidth={300}>
            {config
              ? DICTATION_MODE_LABELS[config.reportDictationMode]
              : 'Aucune préférence enregistrée'}
          </Typography>
        ) : (
          <Select
            sx={{
              width: 400,
              backgroundColor: 'white',
            }}
            value={selectedMode}
            onChange={(e) =>
              setSelectedMode(e.target.value as ReportDictationMode)
            }
          >
            {(Object.keys(DICTATION_MODE_LABELS) as ReportDictationMode[]).map(
              (mode) => (
                <MenuItem key={mode} value={mode}>
                  {DICTATION_MODE_LABELS[mode]}
                </MenuItem>
              ),
            )}
          </Select>
        )}
        {!editMode ? (
          <Button variant="contained" color="secondary" onClick={handleEdit}>
            Modifier
          </Button>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSave}
              disabled={!selectedMode}
            >
              Enregistrer
            </Button>
            <Button variant="outlined" onClick={handleCancel}>
              Annuler
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default MemberPreferenceConfig
